<template>
  <form class="hidden-form" method="POST" :action="url" :target="target">
    <input
      v-for="(field, index) in allFormFields"
      :key="'field_' + index"
      type="hidden"
      :name="field.name"
      :value="field.value"
    />

    <button
      class="btn post-form"
      type="submit"
      :aria-label="ariaLabelText || text"
      :aria-describedby="spanId"
      :class="buttonClass"
      :disabled="disabled || !target"
    >
      <i v-if="icon" class="fa" :class="icon" />

      <span v-if="text" :id="spanId" role="info">{{ text }}</span>
    </button>
  </form>
</template>

<script>
import { Storage } from '@/enums/storage.enum';
import { config } from '@/utils/config';

// @vuese
// Przycisk-formularz
export default {
  props: {
    // Url do wysłania formularza
    url: {
      type: String,
      required: false
    },

    // Target formularza
    target: {
      type: String,
      default: 'debug_window'
    },

    // Pola formularza w formacie:
    // { name: string, value?: any }
    fields: {
      type: Array,
      required: false,
      default: () => []
    },

    // Tekst przycisku do wysłania formularza
    text: {
      type: String,
      required: false
    },

    // Klasa przycisku
    buttonClass: {
      type: String,
      required: false,
      default: 'btn-primary'
    },

    // ikona przycisku
    icon: {
      type: String,
      required: false
    },

    // Przycisk zablokowany
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    // Tekst aria-label
    ariaLabelText: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      spanId: 'span_' + Math.floor(Math.random() * 10000)
    };
  },
  computed: {
    allFormFields() {
      return [
        ...this.fields.map(field => ({
          ...field,
          value: typeof field.value === 'object' ? JSON.stringify(field.value) : field.value
        })),
        { name: config.tokenFormField, value: localStorage.getItem(Storage.TOKEN) }
      ];
    }
  }
};
</script>

<style>
.hidden-form {
  display: inline-block;
}

.hidden-form input {
  display: none;
}
</style>
